
<template>
  <div id="movie" class="main">
    <Hero backimg="background-image:url(/images/hero-movie.jpg)"
      :title="$t('about.movie.banner')"
      sub="" />

    <div class="color-change">
      <AboutMenu />

      <div class="wrap-1500">
        <div class="movie-warp"
          v-for="item in items"
          :key="item.ID">
          <img :src="item.SMALLPIC | imgFilter" alt="">

          <div class="content-wrap"
            @click="gotoPage(item.ID)">
            <div class="content">
              <div class="title ff-dr ft-30">{{ item.PRONAME }}</div>
              <div class="sub ft-20">{{ item.MS }}</div>
              <Knowbtn :dark="false" />
            </div>
          </div>
        </div>

        <div class="btn-wrap" :class="{ hasMore }">
          <Morebtn :dark="true"
            text="加载更多"
            @btn-click="showMore" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue'
import AboutMenu from '@/components/AboutMenu.vue'
import Knowbtn from '@/components/Knowbtn.vue'
import Morebtn from '@/components/Morebtn.vue'
import { getMovieUrl } from '@/util/url.js'
import axios from 'axios'

// const mockData = [
//   {
//     ID: 0,
//     img: '/images/movie-1.png',
//     title: '2019 BLOCKBUSTERS',
//     sub: '今日食品2019年全新企业形象宣传片'
//   },
//   {
//     ID: 1,
//     img: '/images/movie-2.png',
//     title: 'FASHION BUSINESS BLOCKBUSTER',
//     sub: '今日食品全新品牌时尚短片'
//   },
//   {
//     ID: 2,
//     img: '/images/movie-1.png',
//     title: '2019 BLOCKBUSTERS',
//     sub: '今日食品2019年全新企业形象宣传片'
//   },
//   {
//     ID: 3,
//     img: '/images/movie-2.png',
//     title: 'FASHION BUSINESS BLOCKBUSTER',
//     sub: '今日食品全新品牌时尚短片'
//   },
//   {
//     ID: 4,
//     img: '/images/movie-1.png',
//     title: '2019 BLOCKBUSTERS',
//     sub: '今日食品2019年全新企业形象宣传片'
//   },
//   {
//     ID: 5,
//     img: '/images/movie-2.png',
//     title: 'FASHION BUSINESS BLOCKBUSTER',
//     sub: '今日食品全新品牌时尚短片'
//   }
// ]

export default {
  components: {
    Hero,
    AboutMenu,
    Knowbtn,
    Morebtn
  },

  data () {
    return {
      hasMore: false,
      items: []
    }
  },

  mounted () {
    document.title = `${this.$t('nav.about')}-${this.$t('title')}`
    this.$nextTick(() => {
      if (window.scrollBar) window.scrollBar.scrollTop = 0

      // setTimeout(() => {
      //   this.loader.hide()
      // }, 300)
    })

    this.count = 2
    this.step = 2
    this.hasMore = false

    this.fechData()
  },

  methods: {
    fechData () {
      // setTimeout(() => {
      //   this.data = mockData
      //   this.filterData()
      // }, 1000)

      const url = getMovieUrl(this.$store.state.lang)
      axios.get(url).then(res => {
        // console.log(res)
        if (res && res.data && res.data.proarr && res.data.proarr.length > 0) {
          this.data = res.data.proarr
          // console.log(this.data)
          this.filterData()
        }
      })
    },

    filterData () {
      this.items = this.data.slice(0, this.count)
      this.count += this.step

      if (this.data.length > this.items.length) this.hasMore = true
      else this.hasMore = false
    },

    showMore () {
      this.filterData()
    },

    gotoPage (id) {
      this.$router.push(`/sangle1/${id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.main, .color-change {
  background: linear-gradient(#cae6f9, #cae6f9, #fff);
}

.wrap-1500 {
  padding: 30px 0;
  width: 100%;
  margin: 0 auto;
  max-width: 1500px;
}

.movie-warp {
  cursor: pointer;
  margin: 32px;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    transition: transform 5s linear;
  }
}
.movie-warp:hover img {
  transform: scale(1.1)
}

.content-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;

    .title {
      line-height: 60px;
    }
    .sub {
      line-height: 40px;
      margin-bottom: 24px;
    }
  }
}

.btn-wrap.hasMore {
  display: flex;
}
.btn-wrap {
  display: none;
  justify-content: center;
}
@media(max-width: 768px){
  .movie-warp{
    margin-left: 20px;
    margin-right: 20px;
    .content{
      .title{
        font-size: 20px;
        line-height: normal;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .btn-know{
        width: 120px;
        height: 40px;
      }
    }
  }
}
</style>
